import React from 'react';
import SmartDialog from "../SmartDialog";
import {SectionedList} from "../AuditExplorer/Elements";
import {Col, Row} from "reactstrap";
import ProfileAvatar from "../ProfileAvatar";
import Utils from "../../common/Utils";
import NumberLabel from "../NumberLabel/NumberLabel";
import RatingView from "../../views/Operators/RatingView";

class SuggestionDetailDialog extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            suggestionInfo: null
        };
    }

    show(suggestionInfo){

        this.setState({
            suggestionInfo
        }, () => this._dlg.show());

    }

    render() {

        const { suggestionInfo } = this.state;

        return <SmartDialog ref={r => this._dlg = r} title="Detailed Info" large showCancelButton={true}>

            {suggestionInfo && <React.Fragment>

                <Row>

                    <Col md={6}>

                        <h6>Tractor</h6>

                        <Row>

                            <Col md={3}>

                                <ProfileAvatar size={48}
                                               media={suggestionInfo.tractor.media}
                                               name={suggestionInfo.tractor.name}
                                               round={false}
                                               showFullscreen={false} />

                            </Col>

                            <Col md={9}>

                                <SectionedList items={[
                                    {
                                        title: "Name",
                                        value: suggestionInfo.tractor.name
                                    },
                                    {
                                        title: "Registration Number",
                                        value: suggestionInfo.tractor.registration_number
                                    },
                                    {
                                        title: "Chassis",
                                        value: suggestionInfo.tractor.chassis
                                    },
                                    {
                                        title: "Model",
                                        value: suggestionInfo.tractor.tractor_model
                                    },
                                    {
                                        title: "Year",
                                        value: suggestionInfo.tractor.year
                                    },
                                    {
                                        title: "Assigned Requests (Currently)",
                                        mode: "vertical",
                                        value: <span><NumberLabel value={suggestionInfo.properties.totalRequests}/> / <NumberLabel value={suggestionInfo.properties.totalHectares}/> ha</span>
                                    },
                                    {
                                        title: "Completed Requests/Jobs",
                                        mode: "vertical",
                                        value: <span><NumberLabel value={suggestionInfo.properties.totalCompletedRequests}/> / <NumberLabel value={suggestionInfo.properties.totalCompletedHectares}/> ha</span>
                                    },
                                    {
                                        title: "Date Registered",
                                        mode: "vertical",
                                        value: Utils.formatDateStandard(suggestionInfo.tractor.date_created)
                                    }
                                ]}/>

                            </Col>

                        </Row>
                    </Col>

                    <Col md={6}>

                        <h6>Driver/Operator</h6>

                        <Row>

                                <Col md={2}>

                                    <ProfileAvatar size={48}
                                                   media={suggestionInfo.tractor.operator.media}
                                                   name={suggestionInfo.tractor.operator.name}
                                                   round={false}
                                                   showFullscreen={false} />

                                </Col>

                                <Col md={10}>

                                        <SectionedList items={[
                                            {
                                                title: "Name",
                                                value: suggestionInfo.tractor.operator.name
                                            },
                                            {
                                                title: "Phone",
                                                value: suggestionInfo.tractor.operator.phone
                                            },
                                            {
                                                title: "License Class(es)",
                                                value: suggestionInfo.tractor.operator.license
                                            },
                                            {
                                                title: "Completed Requests/Jobs",
                                                mode: "vertical",
                                                value: <span><NumberLabel value={suggestionInfo.properties.operatorCompletedRequests}/> / <NumberLabel value={suggestionInfo.properties.operatorCompletedHectares}/> ha</span>
                                            },
                                            {
                                                title: "Date Registered",
                                                mode: "vertical",
                                                value: Utils.formatDateStandard(suggestionInfo.tractor.operator.date_created)
                                            },
                                            {
                                                mode: "vertical",
                                                value: <RatingView operatorId={suggestionInfo.tractor.operator.id}
                                                                   initialAverageRating={suggestionInfo.properties.averageOperatorRating}
                                                                   initialTotalRating={suggestionInfo.properties.totalOperatorRating}/>
                                            },
                                        ]}/>

                                </Col>

                            </Row>
                    </Col>

                </Row>


            </React.Fragment>}

        </SmartDialog>

    }
}

export default SuggestionDetailDialog;


// WEBPACK FOOTER //
// ./src/components/TractorRequestHandler/SuggestionDetailDialog.js